module.exports = __webpack_public_path__ + "img/송추 맛집.a52173a9.png";